import PropTypes from 'prop-types';
import React from 'react';
import { Spacer } from 'src/core/components';
import Header from 'src/core/components/Title/components/Header';

import MenuItem from '../MenuItem';

const MenuGroupComponent = ({ group, selectedMenuItem, onSelectMenuItem }) => (
  <Spacer top={24}>
    <Spacer left={16}>
      <Header size="5">{group.category.name}</Header>
    </Spacer>
    {group.items.map((item) => (
      <Spacer top={8} key={`${item.name}`}>
        <MenuItem
          category={group.category}
          subcategory={item}
          onSelectMenuItem={onSelectMenuItem}
          selectedMenuItem={selectedMenuItem}
          font="normal"
        />
      </Spacer>
    ))}
  </Spacer>
);

MenuGroupComponent.propTypes = {
  group: PropTypes.object,
  selectedMenuItem: PropTypes.object,
  onSelectMenuItem: PropTypes.func,
};

export default MenuGroupComponent;
